import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    chequesPropios: [],

    cartera: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(90, 'days').format('YYYY-MM-DD'),
    chequesPendientes: true,
    chequesPendientesTodos: true,

    resumenSemanal: [],
    rptChequesPropios: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.chequesPropios = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).add(90, 'days').format('YYYY-MM-DD');
        state.chequesPendientes = true;
        state.chequesPendientesTodos = true;
    },

    'INICIALIZAR'(state) {
        state.chequesPropios = [];
    },
    'SET_CHEQUES_PROPIOS'(state, chequesPropios) {
        state.chequesPropios = [];
        for(let key in chequesPropios) {
            const chequePropio = chequesPropios[key];
            let cheque = {
                id: chequePropio.id,
                fechaCreditoDebito: chequePropio.fechaCreditoDebito,
                bancoCuenta: chequePropio.bancoCuenta,
                numero: chequePropio.numero,
                importe: chequePropio.importe,
                selected: Boolean(false)
            }
            state.chequesPropios.push(cheque);
        }             
    },
    'SET_CHEQUES_SELECCIONADOS'(state, chequesSeleccionados) {
        if (chequesSeleccionados.length != 0) {
            for(let key in state.chequesPropios) {
                let chequePropio = state.chequesPropios[key];
                if (chequesSeleccionados.some(ch => ch.id == chequePropio.id )) {
                    chequePropio.selected = true;
                }
            }
        }
    },

    'INICIALIZAR_CARTERA'(state) {
        state.cartera = [];
    },
    'SET_CARTERA'(state, cartera) {
        state.cartera = cartera;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_RESUMEN_SEMANAL'(state) {
        state.resumenSemanal = [];
    },
    'SET_RESUMEN_SEMANAL'(state, resumenSemanal) {
        state.resumenSemanal = resumenSemanal;
    },

    'INICIALIZAR_RPT'(state) {
        state.rptChequesPropios = [];
    },
    'SET_RPT'(state, rptChequesPropios) {
        state.rptChequesPropios = rptChequesPropios;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getChequesPropiosDisponibles: ( {commit}, chequesSeleccionados ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '';
            
            apiAxios.get('bancosmovimientos/cheques' + queryString)
                .then(res => {
                    commit('SET_CHEQUES_PROPIOS', res.data);
                    
                    if (chequesSeleccionados) {
                        if (chequesSeleccionados != null) {
                            commit('SET_CHEQUES_SELECCIONADOS', chequesSeleccionados);
                        }
                    }

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            })
    },
    getCartera ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CARTERA');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&chequesPendientes='+ state.chequesPendientes
                + '&chequesPendientesTodos='+ state.chequesPendientesTodos;

            apiAxios.get('bancosmovimientos/cheques/cartera' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CARTERA', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getResumenSemanal ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESUMEN_SEMANAL');

            apiAxios.get('bancosmovimientos/cheques/resumen-semanal')
                .then(res => {
                    commit('SET_RESUMEN_SEMANAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptCartera ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&chequesPendientes='+ state.chequesPendientes
                + '&chequesPendientesTodos='+ state.chequesPendientesTodos;

            apiAxios.get('bancosmovimientos/cheques/cartera/rpt' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,

    chequesPropiosSeleccionados(state) {
        let seleccionados = [];
        if (state.chequesPropios.length != 0) {
            seleccionados = state.chequesPropios
                .filter( chp => (/true/i).test(chp.selected) == Boolean(true));
        }
        return seleccionados;
    },
    resumenSemanal(state) {
        return state.resumenSemanal;
    },
    rptChequesPropios(state) {
        return state.rptChequesPropios;
    }    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}